// PaymentAdvanceModal.jsx
import React from 'react';

const PaymentAdvanceModal = ({ isOpen, onClose, paymentDetails }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-4 rounded-lg shadow-lg max-w-sm">
        <h2 className="font-bold text-lg mb-4">Payment Advance Details</h2>
        <p>Taxes: ${paymentDetails.total_taxes}</p>
        <p>Expenses: ${paymentDetails.total_actual_expenses}</p>
        <p>Brokerage: ${paymentDetails.total_custom_brokerage}</p>
        <button
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default PaymentAdvanceModal;
